import { useFlags } from 'launchdarkly-react-client-sdk';

import { AccountDocument, SystemDesign } from 'types';

/** Checks if DC flag is on and the account is _eligible_ (has DC pricing) for DC. */
export const useIsDomesticContentEligible = (account: AccountDocument): boolean => {
  const { domesticContent = false } = useFlags();
  const isDomesticContentEligible = account?.itcAdderQualifications?.domesticContentEligible === true;
  return domesticContent && isDomesticContentEligible;
};

/** Checks if DC flag is on, the account is eligible for *and* has provided affirmative attestation for DC. */
export const useIsDomesticContentEligibleAndAttested = (account: AccountDocument): boolean => {
  const { domesticContent = false } = useFlags();
  const dcAttestment = (account.systemDesign as SystemDesign)?.domesticContentAttestment;

  const isDomesticContentEligible = account?.itcAdderQualifications?.domesticContentEligible === true;
  const isDomesticContentParticipant = dcAttestment?.valueConfirmation === true;

  return domesticContent && isDomesticContentEligible && isDomesticContentParticipant;
};
